<template>
  <i-modal title="Imperia Tiptap Editor">
    <template #default>
      <div class="editor-version">
        <div class="version-text">
          <h3>
          {{ __x('Imperia Tiptap Editor version: {version}', {'version': version} ) }}
          </h3>
          <br />
          {{ __x('Tiptap version: {version}', {'version': tt_version} ) }}
          <br />
          {{ __x('Prosemirror version: {version}', {'version': pm_version} ) }}
        </div>
        <a href="https://tiptap.dev/" target="_blank" rel="noopener noreferrer">
          Tiptap
        </a>
      </div>
    </template>

    <template #footer>
      <div>
        <i-button variant="secondary" @click.prevent="this.$emit('update:show', false);">{{__('Close')}}</i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import globals from '@/globals.js'

export default {
  props: {
    editor: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
     
    };
  },
  methods: {
    __(str) {
      return globals.I.gt.__(str)
    },
    __x(str, params) {
      return globals.I.gt.__x(str, params)
    },
  },
  computed: {
    version() {
      return __APP_VERSION__;
    },
    tt_version() {
      return __TIPTAP_VERSION__;
    },
    pm_version() {
      return __PROSEMIRROR_VERSION__;
    },
  }
};
</script>

<style scoped>
/* Compact Form */
.modal-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
}

.editor-version {
  text-align: center;
  font-size: 1.2rem;
  color: #444;
  margin-top: 1rem;
}

.version-text {
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.editor-version a {
  color: #2a6fd1;
  text-decoration: none;
  font-size: 1rem;
}

.editor-version a:hover {
  text-decoration: underline;
}
</style>